export default "__VITE_ASSET__9135f0e5__"